import { AuthUser } from '@dwelvio/auth-react';
import { AccountMemberRole, AccountPlan, ContactRole, LanguageType, TaskStatus } from './generated/graphql';
import { DateFormatType, NumberFormatType, TimeFormatType } from '@dwelvio/dateutils';
import { OutputData } from '@editorjs/editorjs';

export const ContactRoleTypesArray: ContactRole[] = ['OTHER', 'AGENT', 'TENANT', 'ALLOWED'] as const;
export const ContactRoleTypesLabelArray: { value: ContactRole; label: string }[] = [
  { value: 'OTHER', label: 'iné' },
  { value: 'AGENT', label: 'maklér' },
  { value: 'TENANT', label: 'nájomník' },
  { value: 'ALLOWED', label: 'povolený obyvateľ' },
];

export const TaskStatusTypeArray: TaskStatus[] = ['todo', 'in_progress', 'completed'] as const;
export const TaskStatusTypeLabelArray: { value: TaskStatus; label: string; color: 'default' | 'info' | 'success' }[] = [
  { value: 'todo', label: 'Nezačatá', color: 'default' },
  { value: 'in_progress', label: 'V riešení', color: 'info' },
  { value: 'completed', label: 'Dokončená', color: 'success' },
];

export const NumberFormatTypeLabelArray: { value: NumberFormatType; label: string }[] = [
  { value: 'DE', label: '1.234,56' },
  { value: 'US', label: '1,234.56' },
  { value: 'UK', label: '1 234,56' },
];

export const DateFormatTypeLabelArray: { value: DateFormatType; label: string }[] = [
  { value: 'DMY', label: 'DD/MM/YYYY' },
  { value: 'MDY', label: 'MM/DD/YYYY' },
  { value: 'YMD', label: 'YYYY-MM-DD' },
];

export const TimeFormatTypeLabelArray: { value: TimeFormatType; label: string }[] = [
  { value: 'H24', label: '24 hodín' },
  { value: 'H12', label: '12 hodín' },
];

export const PlanTypeLabelArray: { value: AccountPlan; label: string }[] = [
  { value: 'free', label: 'Free' },
  { value: 'standard', label: 'Standard' },
];

export const LanguageTypeLabelArray: { value: LanguageType; label: string }[] = [{ value: 'sk', label: 'Slovenčina' }];

export interface IUserData extends AuthUser {
  id: string;
  accountId?: string;
  username: string;
  email: string;
  token: string;
  accounts: Account[];
  /** Time Zone */
  tz: string;
  /** Language */
  lang: string;
  /** Formatting */
  fmtNum: NumberFormatType;
  fmtDate: DateFormatType;
  fmtTime: TimeFormatType;
}

export interface Account {
  id: string;
  name: string;
  plan: AccountPlan;
  roles: AccountMemberRole[];
}

export const PlanLimitsArray = ['properties', 'storage', 'account_members'] as const;
export type PlanLimit = (typeof PlanLimitsArray)[number];

export const AccountPlanLimitLabels: { [key in PlanLimit]: string } = {
  properties: 'Počet nehnuteľností',
  storage: 'Úložný priestor (MB)',
  account_members: 'Počet používateľov účtu',
};

export type DocumentContent = OutputData;
